<div class="row">
    <div class="col-6">
        <div class="mb-3">
            <label class="form-label">Cantidad dias para atras</label>
            <input type="number" class="form-control" [(ngModel)]="pregunta.Minimo" [disabled]="accesoPublico">
        </div>
    </div>
    <div class="col-6">
        <div class="mb-3">
            <label class="form-label">Cantidad dias para adelante</label>
            <input type="number" class="form-control" [(ngModel)]="pregunta.Maximo" [disabled]="accesoPublico">
        </div>
    </div>
</div>
